<template>
  <aside class="app-sidebar noprint" :class="{ 'app-sidebar--compact': compact }">
    <button
      type="button"
      class="app-sidebar__toggle"
      :aria-label="compact ? 'Expand sidebar' : 'Collapse sidebar'"
      @click="toggleCompact">
      <i class="fa-solid" :class="compact ? 'fa-chevrons-right' : 'fa-chevrons-left'" />
    </button>

    <div class="app-sidebar__wrapper">
      <ul>
        <li
          v-for="item in sidebarItems"
          :key="item.href">
          <AppLink
            :href="item.href"
            class="app-sidebar__item"
            :class="{ active: item.active }">
            <i
              v-if="item.icon"
              :class="item.icon" />
            <span>{{ item.label }}</span>
          </AppLink>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { SIDEBAR_VIEW_MODE_KEY } from '@/config/sidebars/init'
import { saveToStorage } from '@/helpers/storage'

const globalStore = useGlobalStore()

const sidebarItems = computed(() => (globalStore.sidebar?.items || [])
  .filter((item) => !item.show || item.show(globalStore)))

const compact = computed(() => Boolean(globalStore.sidebar?.compact))

function toggleCompact() {
  if (!globalStore.sidebar) return

  const next = !globalStore.sidebar.compact
  globalStore.sidebar.compact = next
  saveToStorage(SIDEBAR_VIEW_MODE_KEY, next)
}
</script>
